import { createSegment } from 'chem-generic-ui';
import Element from 'src/models/Element';

// Create Segment class
const Segment = createSegment(Element);

export default Segment;
